import humps from 'humps';
import { isNil } from 'ramda';

import { GAME_RESULT, NO_MORE_BETS, VIDEO } from '@ezugi/constants';
import { NanoPlayerConfig, NanoPlayerStreamEntry, RawNanoPlayerConfig } from '@ezugi/types/src';
import { mapPropNames } from '@ezugi/utils';

const { HIGH_RESOLUTION, BITRATE_MAP }: any = VIDEO;

export const camelize = mapPropNames(humps.camelize);

const formatNanoStream = (stream: NanoPlayerStreamEntry, index: number): NanoPlayerStreamEntry => {
  const {
    defaultPlatform,
    bitrate,
    label,
    url: streamname,
    location: url,
    token = { value: '' },
    rendition,
  } = stream;

  return {
    ...stream,
    key: index,
    index,
    /*
    * Nano does some kind of reflection on the object and will fail
    * to play the stream if there are null values, so we default it to an empty string
    */
    defaultPlatform: isNil(defaultPlatform) ? '' : defaultPlatform,
    rendition: isNil(rendition) ? 'unknown' : rendition,
    label: label || `stream ${index}`,
    info: {
      bitrate: bitrate || BITRATE_MAP[HIGH_RESOLUTION],
    },
    h5live: {
      rtmp: {
        url,
        streamname,
      },
      server: {
        websocket: 'wss://bintu-h5live-secure.nanocosmos.de:443/h5live/authstream/stream.mp4',
        hls: 'https://bintu-h5live-secure.nanocosmos.de:443/h5live/authhttp/playlist.m3u8',
        progressive: 'https://bintu-h5live-secure.nanocosmos.de:443/h5live/authhttp/stream.mp4',
      },
      security: {
        expires: '',
        tag: '',
        jwtoken: token.value,
      },
    },
    bintu: {},
  };
};

export const formatNanoStreams = (data: RawNanoPlayerConfig): NanoPlayerConfig => {
  const { front = [], top = [], delay: _delay, videoDelay } = data;
  front.sort((a, b) => b.bitrate - a.bitrate);
  top.sort((a, b) => b.bitrate - a.bitrate);

  const sanitizedVideoDelay = parseFloat(videoDelay);

  return {
    ...data,
    videoDelay: Number.isNaN(sanitizedVideoDelay) ? 0 : sanitizedVideoDelay,
    front: front.map(formatNanoStream),
    top: top.map(formatNanoStream),
  };
};

export const isNoMoreBets = (roundStatus: string) => [ GAME_RESULT, NO_MORE_BETS ].includes(roundStatus);
